import {TRoundingRules} from '@web-catalog/types/omicron';

const localeMapper: Record<string, string> = {
  '0': '',
  '1': '\u00a0тыс.',
  '2': '\u00a0млн',
  '3': '\u00a0млрд',
  '4': '\u00a0трлн',
};

export const shortNumFormat = (num: number) => {
  if (!num || isNaN(num)) return '0';

  const thousands = Math.floor((('' + num).length - 1) / 3);

  const cf = 1000 ** thousands;
  const finalNum = Number(num / cf);

  if ((finalNum % 1) * 10 >= 9 || finalNum % 1 === 0) {
    return Number(num / cf).toFixed(0) + localeMapper[thousands] || 'трлн.';
  }

  return (
    Number(num / cf)
      .toFixed(1)
      .replace('.', ',') + localeMapper[thousands] || 'трлн.'
  );
};

export const shortDownLoadsFormat = (
  num: number,
  roundingRules: TRoundingRules | boolean,
) => {
  if (!roundingRules) {
    const SMALL_NUM_COUNT = 10;
    let stringEnd = '';

    if (num > SMALL_NUM_COUNT) {
      stringEnd = '+';

      return `${shortNumFormat(num)}${stringEnd}`;
    }
  }

  if (Array.isArray(roundingRules)) {
    for (let i = 0; i < roundingRules.length; i++) {
      const isMoreOrEqualMin = roundingRules[i].min <= num;

      const isLessThenNext = roundingRules[i + 1]?.min > num;

      const isCurrentRoundRule = roundingRules[i + 1]?.min
        ? isMoreOrEqualMin && isLessThenNext
        : isMoreOrEqualMin;

      if (isCurrentRoundRule) {
        return roundingRules[i].text;
      }
    }
  }
};
